import type { LocaleValue } from "utilities/locale";

export const titlePriorityByLocale: Partial<Record<LocaleValue, string[]>> = {
  "en-ca": [
    "ice_hockey",
    "basketball",
    "american_football",
    "baseball",
    "soccer",
    "tennis",
    "table_tennis",
    "golf",
    "formula_one",
    "motorsport",
  ],
};

export const getTitlePriorityByLocale = (
  locale: string | null | undefined,
  slug: string,
) => {
  const priority = titlePriorityByLocale[locale as LocaleValue] ?? [];
  const i = priority.indexOf(slug);
  return i === -1 ? Infinity : i;
};
